import { isArabic } from '../global';
import Master from "./Master"

import "../styles/global.css";

const Faq = () => {

    return (
        <Master root='terms' withBG={false} >
            <div className="content">
                <div className='Header'>الأسئلة الشائعة</div>
                    <br/>
                    <div className='Padding5'>
                        <section className='Column'>
                            
                            {/* <div className='Header '>الشروط والأحكام</div>
                            <div className='SubHeader '>الشروط والأحكام</div>
                            <br/> */}
                            
                        </section>
                    </div>
                <br/><br/>
            </div>
        </Master>
    )
    
}

export default Faq;
